import $ from '@modules/jquery-import';

function debounce ( func, threshold, execAsap ) {
    let timeout;

    return function debounced () {
        const obj = this,
            args = arguments;

        function delayed () {
            if ( !execAsap ) {
                func.apply( obj, args );
            }
            timeout = null;
        };

        if ( timeout ) {
            clearTimeout( timeout );
        }
        else if ( execAsap ) {
            func.apply( obj, args );
        }

        timeout = setTimeout( delayed, threshold || 150 );
    };
}

$.fn.smartresize = function ( fn ) {
    return fn
        ? this.bind( 'resize', debounce( fn ) )
        : this.trigger( 'smartresize' );
};
